import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/arbeitsrecht.webp";

const data: AreaContent = {
  id: Area.ARBEITSRECHT,
  hero: hero,
  content: [
    "Wir beraten und vertreten Arbeitgeber:innen und Arbeitnehmer:innen in allen Bereichen des individuellen und kollektiven Arbeitsrechts. Unsere Beratung umfasst neben der Unterstützung im laufenden Arbeitsverhältnis insbesondere die Verhandlungsführung mit Betriebs- und Personalräten, die Vertretung vor Arbeits-, Zivil- und Verwaltungsgerichten sowie vor Einigungsstellen.",
    "Unser Leistungsspektrum im Arbeitsrecht umfasst unter anderem:",
    [
      "Gestaltung und Prüfung von Arbeitsverträgen",
      "Beratung von Arbeitnehmer:innen und Arbeitgeber:innen vor und nach Ausspruch einer Kündigung",
      "Vertretung in Kündigungsschutzprozessen",
      "Verhandlung und Abschluss von Vergleichen, Abwicklungs- und Aufhebungsverträgen",
      "Beratung zu Abfindungen sowie den damit verbundenen sozial- und steuerrechtlichen Fragen",
      "Beratung und Vertretung bei Streitigkeiten über Teilzeitarbeit, Zeugnisse, Versetzungen, Urlaub und Abmahnungen",
    ],
  ],
  bullets: [
    "Arbeits- und Dienstverträge",
    "Kündigungen",
    "Kündigungsschutz",
    "Aufhebungsvereinbarungen",
    "Sozialversicherungsrecht",
    "Betriebsverfassungsrecht",
  ],
  more: [],
};

export default data;
